(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["r-custom-configurators"] && !Shopify.designMode) return;
  try {
    (() => {
    const initCreators = (container) => {
      container.querySelectorAll('[data-custom-creators]').forEach(root => {
        if (root.dataset.creatorsReady) return;
        root.dataset.creatorsReady = 'true';
        const panels = [...root.querySelectorAll('[data-creator-panel]')];
        const links = [...root.querySelectorAll('[data-open-creator]')];
        let lastTrigger;
        const show = (kind, navigate = false) => {
          const panel = panels.find(item => item.dataset.creatorPanel === kind);
          panels.forEach(item => { item.hidden = item !== panel; });
          links.forEach(link => link.setAttribute('aria-expanded', String(Boolean(panel) && link.dataset.openCreator === kind)));
          if (!panel) return false;
          const frame = panel.querySelector('iframe[data-configurator-src]');
          if (frame && !frame.hasAttribute('src')) frame.src = frame.dataset.configuratorSrc;
          else if (frame) frame.dispatchEvent(new Event('raso:reveal'));
          if (navigate) {
            panel.querySelector('h3').focus({ preventScroll: true });
            panel.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
          }
          return true;
        };
        links.forEach(link => link.addEventListener('click', event => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
          if (!panels.some(panel => panel.dataset.creatorPanel === link.dataset.openCreator)) return;
          event.preventDefault();
          lastTrigger = link;
          history.pushState(null, '', '#configurateur-' + link.dataset.openCreator);
          show(link.dataset.openCreator, true);
        }));
        root.querySelectorAll('[data-close-creator]').forEach(button => button.addEventListener('click', () => {
          show(null);
          history.replaceState(null, '', '#personnaliser');
          (lastTrigger || links[0])?.focus({ preventScroll: true });
          root.scrollIntoView({ block: 'start', behavior: 'auto' });
        }));
        const restoreHash = () => {
          const kind = location.hash.replace('#configurateur-', '');
          show(kind, panels.some(panel => panel.dataset.creatorPanel === kind));
        };
        window.addEventListener('hashchange', restoreHash);
        window.addEventListener('popstate', restoreHash);
        restoreHash();
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initCreators(document));
    else initCreators(document);
    document.addEventListener('shopify:section:load', event => initCreators(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["stock-request"] && !Shopify.designMode) return;
  try {
    const updateStockRequest = (root, available, variantId, variantTitle) => {
  root.hidden = available;
  const variantField = root.querySelector('[data-stock-request-variant]');
  const idField = root.querySelector('[data-stock-request-variant-id]');
  if (variantField && variantTitle) variantField.value = variantTitle;
  if (idField && variantId) idField.value = variantId;
};

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-stock-request-toggle]');
  if (!toggle) return;
  const root = toggle.closest('[data-stock-request]');
  const panel = root?.querySelector('[data-stock-request-panel]');
  if (!panel) return;
  panel.hidden = !panel.hidden;
  toggle.setAttribute('aria-expanded', String(!panel.hidden));
});

document.addEventListener('change', (event) => {
  const roots = document.querySelectorAll('[data-stock-request]');
  if (event.target.matches('[data-variant-select]')) {
    const option = event.target.selectedOptions[0];
    const title = option.textContent.split('—')[0].trim();
    roots.forEach((root) => updateStockRequest(root, option.dataset.available === 'true', option.value, title));
  }
  if (event.target.matches('[data-series-variant]')) {
    roots.forEach((root) => updateStockRequest(root, event.target.dataset.available === 'true', event.target.value, event.target.dataset.title));
  }
});
  } catch(e) { console.error(e); }
})();

})();
